<script setup>
const props = defineProps(['pagination']);
const emit = defineEmits(['page-change']);

const { theme } = useTheme();

const paginationLinks = computed(() => {
    return props.pagination?.links ? props.pagination.links.slice(1, -1) : [];
});

const paginate = (url) => {
    if (!url) return;

    const urlObj = new URL(url);
    const page = urlObj.searchParams.get('page') || 1;
    
    emit('page-change', page);
};

const activeStyle = computed(() => ({
    borderBottomColor: theme.value.medium,
    color: theme.value.linkText
}));

</script>

<template>
    <div class="w-full flex justify-between items-center">
        <div>
            <button
               :class="['border-r py-3 px-4 flex items-center transition-colors', props.pagination.prev ? 'text-gray-800 cursor-pointer' : 'text-gray-400 cursor-not-allowed']"
               :disabled="!props.pagination.prev"
               @mouseenter="props.pagination.prev && ($event.target.style.color = theme.linkText)"
               @mouseleave="props.pagination.prev && ($event.target.style.color = '')"
               @click="paginate(props.pagination.prev)"
            >
                <font-awesome class="w-4 h-4 mr-1" :icon="['fas', 'arrow-left']" /> Prev
            </button>
        </div>

        <div class="flex-1 flex justify-center">
            <button
               v-for="link in paginationLinks"
               :key="link.label"
               :class="['py-3 px-3 mx-1 transition-colors border-b-2', link.active ? 'font-medium' : 'text-gray-700 hover:rounded border-transparent']"
               :style="link.active ? activeStyle : {}"
               @mouseenter="!link.active && ($event.target.style.color = theme.linkText)"
               @mouseleave="!link.active && ($event.target.style.color = '')"
               @click="paginate(link.url)"
            >
                {{ link.label }}
            </button>
        </div>

        <div>
            <button
               :class="['border-l py-3 px-4 flex items-center transition-colors', props.pagination.next ? 'text-gray-800 cursor-pointer' : 'text-gray-400 cursor-not-allowed']"
               :disabled="!props.pagination.next"
               @mouseenter="props.pagination.next && ($event.target.style.color = theme.linkText)"
               @mouseleave="props.pagination.next && ($event.target.style.color = '')"
               @click="paginate(props.pagination.next)"
            >
                Next <font-awesome class="w-4 h-4 ml-1" :icon="['fas', 'arrow-right']" />
            </button>
        </div>
    </div>
</template>